// extracted by mini-css-extract-plugin
export default {"standings":"Table_standings__SuXdB"};